import { SecuredWsApi } from "@/utils/http-client";

export default {
  getMerchantPayerCompanies(transactionId) {
    return SecuredWsApi.get("/api/paymentflow/v1/merchant/payer-companies", { transactionId });
  },
};
